var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "회사소개",
      "sc": "에프원시큐리티가 여러분의 정보를 함께 보호하겠습니다.",
      "tabActive": "조직도",
      "icon": "/images/sub/visual/sv1-icon.svg",
      "bg": "/images/sub/visual/sv1.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--lg mb-28 mb-lg-54",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("F1 Security")]), _vm._v(" 는 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 다양한 구성원 으로 이루어져 있습니다 ")]), _c('div', {
    staticClass: "pa-16 pa-md-60 w-100 bg-grey radius-md"
  }, [_c('v-img', {
    staticClass: "d-none d-md-block mx-auto",
    attrs: {
      "max-width": "865",
      "src": "/images/sub/about/org/org.png"
    }
  }), _c('v-img', {
    staticClass: "d-block d-md-none mx-auto",
    attrs: {
      "max-width": "524",
      "src": "/images/sub/about/org/org-mo.png"
    }
  })], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }